/** These strings aren't customer-facing: these don't need to be localized. */
export const CARD_DECLINED = {
  name: 'Polar Bear',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/5/56/Coca-Cola.svg/revision/latest/scale-to-width-down/300?cb=20201226072509',
};
